/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Library_SortInputs */

const en_settings_v2_library_sort = /** @type {(inputs: Settings_V2_Library_SortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Library order`)
};

const es_settings_v2_library_sort = /** @type {(inputs: Settings_V2_Library_SortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orden de la biblioteca`)
};

/**
* | output |
* | --- |
* | "Library order" |
*
* @param {Settings_V2_Library_SortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_library_sort = /** @type {((inputs?: Settings_V2_Library_SortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Library_SortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_library_sort(inputs)
	return en_settings_v2_library_sort(inputs)
});